import { Tooltip } from 'antd';
import RenderCopyIcon from './RenderCopyIcon';

const MappedUnitsCell = ({ units, zIndex = 4 }) => {
  const mappedUnits = (units || [])?.filter(
    (unit) => unit?.qrCode || unit?.unitCode,
  );
  if (!mappedUnits?.length) return '-';

  return (
    <div className="mapped-units-cell">
      {mappedUnits?.map((unit) => {
        const code = unit?.qrCode || unit?.unitCode;
        const location = [unit?.rack?.name, unit?.shelfLocation]
          ?.filter(Boolean)
          ?.join(' / ');
        return (
          <div className="d-flex align-center" key={unit?.id || code}>
            <RenderCopyIcon
              copyText={code}
              toolTipText="Copy QR Code"
              zIndex={zIndex}
            />
            <Tooltip
              title={location ? `Shelf: ${location}` : undefined}
              placement="top"
              zIndex={zIndex}
            >
              <span className="table-data-with-id">{code}</span>
            </Tooltip>
          </div>
        );
      })}
    </div>
  );
};

export default MappedUnitsCell;
